import React, { FC, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AlertBubbleIcon } from '@shopify/polaris-icons';
import { Navigation } from '@shopify/polaris';

import Grid from '@mui/material/Grid';

const PhotoPagesSidebar: FC = () => {
  const location = useLocation();

  const navigationItems = [];

  navigationItems.push({
    label: 'Photo Pages',
    url: '/photo_pages',
    icon: AlertBubbleIcon as any,
    matches: true,
    subNavigationItems: [
      {
        url: '/photo_pages',
        disabled: false,
        label: 'XOI Jobs',
      },
    ],
  });

  return (
    <Grid container>
      <Grid item xs={12}>
        <Navigation location={location.pathname}>
          <Navigation.Section items={navigationItems} />
        </Navigation>
      </Grid>
    </Grid>
  );
};

export default PhotoPagesSidebar;
